import { Button } from "@material-tailwind/react";
import { useOnboardingStore } from "../../store/onboarding/Onboarding";
import logo from "../../assets/images/logo.svg";
import { useNavigate } from "react-router-dom";

function SelectAccount() {
  const handleButtonClick = (type: "individual" | "cooperate") => {
    setAccountType(type);
  };

  const { accountType, setAccountType } = useOnboardingStore();
  const navigation = useNavigate();
  return (
    <div className="md:flex w-screen md:h-screen bg-gray-50">
      <div className="invisible md:visible bg-map-background bg-no-repeat w-3/6 relative flex flex-col justify-center items-center">
        <img
          className="  absolute md:top-10 md:left-20"
          src={logo}
          alt="GIGM Logo"
        />
        <div className="text-4xl">
          <h1>It’s easier to get</h1>
          <h2 className="inline">started with{` `}</h2>
          <h2 className="inline font-extrabold text-primary">GIGM Boat</h2>
        </div>
      </div>
      <img className="ml-20 md:hidden" src={logo} alt="GIGM Logo" />
      <div className="flex items-center justify-center ">
        <div className="md:w-[60%] md:m-24 m-10">
          <h2 className=" text-2xl text-center">Select account type</h2>

          <div>
            <div className="my-12 normal-case text-center flex flex-col gap-5 items-center">
              <Button  placeholder={undefined} 
                variant={accountType === "individual" ? "filled" : "outlined"}
                onClick={() => handleButtonClick("individual")}
                className="text-left normal-case  w-full h-20 rounded-xl border-gray-400 font-normal text-sm"
              >
                <p>I am an Individual</p>
                <p className="text-gray-500 font-normal">
                  This boat is owned and registered under my name
                </p>
              </Button>
              <Button  placeholder={undefined} 
                variant={accountType === "cooperate" ? "filled" : "outlined"}
                onClick={() => handleButtonClick("cooperate")}
                className="text-left normal-case w-full h-20 rounded-xl border-gray-400 font-normal text-sm"
              >
                <p>A Co-operation Company</p>
                <p className="text-gray-500 font-normal">
                  This boat is owned and registered under my name
                </p>
              </Button>
            </div>
            {accountType && (
              <Button  placeholder={undefined} 
                className="mt-10 bg-primary"
                fullWidth
                onClick={() => navigation("/signUp")}
              >
                GET STARTED
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectAccount;
